import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const GeneralSettingsContext = createContext();

export const useGeneralSettings = () => {
  const context = useContext(GeneralSettingsContext);
  if (!context) {
    throw new Error('useGeneralSettings must be used within GeneralSettingsProvider');
  }
  return context;
};

export const GeneralSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/general-settings/general`);
      setSettings(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching general settings:', err);
      setError(err);
      // Fail OPEN, not closed. This fallback used to have a totally
      // different (legacy) shape with no `status` key at all —
      // StatusGuard reads `settings?.status?.isActive`, which came back
      // `undefined` from that shape, and `!undefined` is `true`, so
      // StatusGuard redirected every real visitor (and every crawler,
      // including Google) unlucky enough to hit this catch block
      // straight to the coming-soon page — indistinguishable from the
      // site actually being toggled inactive in the admin, even though
      // nothing was. Any transient blip fetching this endpoint (a slow
      // network, a backend restart during a deploy, ...) was enough to
      // trigger it. `isActive: true` here means a fetch failure now
      // correctly falls back to showing the real site.
      setSettings({
        socialNetworks: [],
        status: { isActive: true },
        storeName: 'Cimonamia',
        storeTagline: 'LESS WASTE, MORE STYLE'
      });
    } finally {
      setLoading(false);
    }
  };

  const value = {
    settings,
    loading,
    error,
    refetch: fetchSettings
  };

  return (
    <GeneralSettingsContext.Provider value={value}>
      {children}
    </GeneralSettingsContext.Provider>
  );
};

export default GeneralSettingsContext;
